import * as I18n from 'i18n-js'
import * as ReactDOM from 'react-dom'
import * as React from 'react'
import axios from 'axios'

import { MobileBanner, Banner } from 'carpool_shared/components/download_app_banner'

declare let gon: {
  banner_store_ios_url: string
  banner_store_android_url: string
  banner_onboard_url: string
  config: {
    flags: {
      carpool_available_country_codes: string[]
    }
  }
}

declare let window: {
  optimizeBannerCallback: (variant: number) => void
}

declare let dataLayer: any

const container = document.querySelector('.download-app-banner')
const WEB_BANNER_LOCAL_STORAGE_KEY = 'downloadWebBannerClosedTimestamp'

const countryAvailable = async () => {
  try {
    const { data } = await axios.get('/web_api/request_info')
    return gon.config.flags.carpool_available_country_codes.indexOf(data.region) >= 0
  } catch {
    return false
  }
}

const showDownloadBanner = async (checkCountry: boolean) => {
  if (container && (!checkCountry || (await countryAvailable()))) {
    const body = I18n.t('carpool.download_banner.body_general')
    const cta = I18n.t('carpool.download_banner.cta_get')

    ReactDOM.render(
      <MobileBanner
        iosBody={body}
        androidBody={body}
        cta={cta}
        iosLink={gon.banner_store_ios_url}
        androidLink={gon.banner_store_android_url}
        localStorageKey={WEB_BANNER_LOCAL_STORAGE_KEY}
        bannerType='download-rider'
      />,
      container
    )
  }
}

const showGoToOnboardBanner = async (checkCountry: boolean) => {
  if (container && (!checkCountry || (await countryAvailable()))) {
    const body = I18n.t('carpool.download_banner.body_general')
    const cta = I18n.t('carpool.download_banner.cta_try_now')

    ReactDOM.render(
      <Banner
        body={body}
        cta={cta}
        link={gon.banner_onboard_url}
        localStorageKey={WEB_BANNER_LOCAL_STORAGE_KEY}
        bannerType='onboard'
      />,
      container
    )
  }
}

window.optimizeBannerCallback = (variant: number) => {
  if (variant === 1) {
    showDownloadBanner(false)
  } else {
    showGoToOnboardBanner(false)
  }
}

dataLayer.push({ event: 'optimize.websiteBannerReady' })
